import { combineReducers } from '@reduxjs/toolkit';

import globalReducer from './globalSlice';

const appReducer = combineReducers({
  global: globalReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action);
};

export default rootReducer;
